export function accordionScrollInit() {
    const accordionButtons = document.querySelectorAll('.accordion-button');
    accordionButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
            setTimeout(() => {
                const targetId = button.getAttribute('data-bs-target');
                const targetElement = document.querySelector(targetId);

                if (targetElement.classList.contains('show')) {
                    const headerOffset = 130;
                    const elementPosition = targetElement.getBoundingClientRect().top;
                    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

                    window.scrollTo({top: offsetPosition, behavior: 'smooth'});
                }
            }, 600);
        });
    });
}
